import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialFloatOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {color} from "@cm/graph-v3"

export interface SeparateRgbSockets extends MaterialNodeSockets {
    inputs: {
        image: "color" // found in inputs: color; found in settings: color; inferred from data: float3
    }
    settings: {
        b: "float" // found in inputs: -; found in settings: float; inferred from data: float
        g: "float" // found in inputs: -; found in settings: float; inferred from data: float
        image: "color" // found in inputs: color; found in settings: color; inferred from data: float3
        r: "float" // found in inputs: -; found in settings: float; inferred from data: float
    }
    outputs: {
        r: "float"
        g: "float"
        b: "float"
    }
}

export const separateRgbDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeSeparateRGB,
    },
    nodeClass: "SeparateRgb",
    ui: {
        label: "Separate RGB",
        color: "#4987af",
        items: [
            {name: "r", valueType: "float", label: "R", output: true},
            {name: "g", valueType: "float", label: "G", output: true},
            {name: "b", valueType: "float", label: "B", output: true},
            {name: "image", valueType: "color", label: "Image", input: true, setting: true, defaultValue: {r: 0.0, g: 0.0, b: 0.0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({r: materialFloatOutput, g: materialFloatOutput, b: materialFloatOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({image: optionalMaterialInput}),
            settings: z.strictObject({
                b: z.optional(z.number()),
                image: z.optional(color),
                g: z.optional(z.number()),
                r: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<SeparateRgbSockets>
